import React from 'react';

type BillingTabProps = {
  info: string;
};

function BillingTab({ info }: BillingTabProps) {
  return <div className="" />;
}

export default BillingTab;
